const EMPTY_HEIGHT = { unit: 'imperial', feet: '', inches: '', cm: '' };

/** Parse stored height_display for form controls. */
export function parseHeightDisplay(raw) {
	const trimmed = String(raw || '').trim();
	if (!trimmed) {
		return { ...EMPTY_HEIGHT };
	}

	const cmMatch = trimmed.match(/^(\d{2,3})\s*cm$/i);
	if (cmMatch) {
		return { unit: 'metric', feet: '', inches: '', cm: cmMatch[1] };
	}

	const imperialMatch = trimmed.match(/^(\d)\s*['′]\s*(\d{1,2})/);
	if (imperialMatch) {
		return {
			unit: 'imperial',
			feet: Number(imperialMatch[1]),
			inches: Number(imperialMatch[2]),
			cm: ''
		};
	}

	return { ...EMPTY_HEIGHT };
}

export function imperialSelectionComplete(feet, inches) {
	return feet !== '' && inches !== '' && Number.isFinite(Number(feet)) && Number.isFinite(Number(inches));
}

/** Format for API height_display (max 32 chars). */
export function formatHeightDisplay({ unit, feet, inches, cm }) {
	if (unit === 'metric') {
		const n = Number(cm);
		if (!Number.isFinite(n) || n < 1) return '';
		return `${Math.round(n)} cm`;
	}

	if (!imperialSelectionComplete(feet, inches)) return '';

	const f = Number(feet);
	const i = Number(inches);
	if (f < 1) return '';
	const inchPart = Math.min(11, Math.max(0, Math.round(i)));
	return `${Math.round(f)}'${inchPart}"`;
}

export function isHeightDisplayValid(raw) {
	return formatHeightDisplay(parseHeightDisplay(raw)) !== '' || String(raw || '').trim().length > 0;
}

export const HEIGHT_FEET_OPTIONS = [4, 5, 6, 7];
export const HEIGHT_INCHES_OPTIONS = Array.from({ length: 12 }, (_, n) => n);

export function imperialToCm(feet, inches) {
	if (!imperialSelectionComplete(feet, inches)) return '';
	const totalInches = Number(feet) * 12 + Number(inches);
	if (!Number.isFinite(totalInches) || totalInches < 1) return '';
	return Math.round(totalInches * 2.54);
}

export function cmToImperial(cm) {
	const totalInches = Math.round(Number(cm) / 2.54);
	if (!Number.isFinite(totalInches) || totalInches < 1) {
		return { feet: '', inches: '' };
	}
	const feet = Math.floor(totalInches / 12);
	const inches = totalInches % 12;
	return {
		feet: Math.min(HEIGHT_FEET_OPTIONS[HEIGHT_FEET_OPTIONS.length - 1], Math.max(HEIGHT_FEET_OPTIONS[0], feet)),
		inches: inches
	};
}
